export interface PollingOptions<T> {
  fetch: () => Promise<T>;
  isResolved: (result: T) => boolean;
  maxRetries?: number;
  intervalMs?: number;
}

export async function pollUntil<T>({
  fetch,
  isResolved,
  maxRetries = 10,
  intervalMs = 3000,
}: PollingOptions<T>): Promise<void> {
  let attempt = 0;

  while (attempt < maxRetries) {
    const result = await fetch();

    if (isResolved(result)) {
      return;
    }

    attempt++;
    if (attempt < maxRetries) {
      await new Promise((resolve) => setTimeout(resolve, intervalMs));
    }
  }

  throw new Error("Polling condition not met within retry limit.");
}
